import { render } from "./FormResetPassComponent.vue?vue&type=template&id=c61c6bd2&scoped=true"
import script from "./FormResetPassComponent.vue?vue&type=script&lang=js"
export * from "./FormResetPassComponent.vue?vue&type=script&lang=js"

import "./FormResetPassComponent.vue?vue&type=style&index=0&id=c61c6bd2&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61c6bd2"]])

export default __exports__